import { Injectable } from '@angular/core';
import { ITag } from '../../models/tag';
import { isNil } from 'ramda/es';
import { TranslateService } from '@ngx-translate/core';

const pattern: RegExp = /(\(!--[^-]*--\))/;

@Injectable()
export class TagsFormatService {
  private limit: number = 5; // Max recursion limit for tags

  constructor(private translateService: TranslateService) {}

  /**
   * This method render the texts with tags content
   * @param text: The text containing tags
   * @param tags: The tag list
   * @param format: Function which is responsible of formating tag,
   *                it receive the tag, so you can do what ever you
   *                want with it such as generating html, etc ..
   * @param index: (optional) the index of the recursion
   */
  public makeText(text: string, tags: ITag[], format: Function, index: number = 0) {
    return text
      .split(pattern)
      .map(word => {
        const tag = tags.find(t => t.tag === word);
        return isNil(tag)
          ? word
          : pattern.test(tag.value) && index < this.limit
            ? format(tag.tag, this.makeText(tag.value, tags, format, index + 1))
            : format(tag.tag, tag.value || tag.label);
      })
      .join('');
  }

  public getTagHtml(name: string, value: string): string {
    const tagValue = value || this.translateService.instant(`tags.raw.${name}`);
    return `<span class="chip" spellcheck="false" data-tag='${name.replace(/"/g, '&quot;')}' contenteditable="false">${tagValue}</span>`;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/tags/tags-format.service.ts